export default [
  {
    uid: "01",
    Senderid: "1234",
    Campaignid: "1q2we4",
    content: "Lorem ipsum is a placeholder text commonly",
    totalCount: "15",
    Schedule: "2021-11-10",
  },
  {
    uid: "02",
    Senderid: "5678",
    Campaignid: "1q2we4",
    content: "Lorem ipsum is a placeholder text commonly ",
    totalCount: "20",
    Schedule: "2021-11-10",
  },
];
